module.exports = __webpack_public_path__ + "img/File.d669dc97.svg";